module.exports = "<div class=\"tracking-row q-marg-bottom-md\"> <div class=stp-left-input-outer> <input id=\"tracking-{%- trackingId %}\" required class=\"q-input q-stretch tracking-number\" name=\"tracking-{%- trackingId %}\" type=text placeholder=\"Enter the tracking number\"/> </div> <div class=stp-right-input-outer> <a href=# class=remove-btn> &times; </a> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/order/components/shipThirdPartyModal/html/trackingRow.html
// module id = 1354
// module chunks = 1